import React, { useState, useContext, useEffect } from "react";
import { useMutation, useApolloClient } from "react-apollo";
import { useParams, useHistory } from "react-router-dom";
import {
  ALL_DRUG_TESTS_VIEW_QUERY,
  DRUG_TEST_PAGINATION_QUERY,
  CLOSE_DRUG_TEST_BATCH_NO_MUTATION
} from "../../../graphql/DrugTests/DrugTests.graphql";
import DrugTestFilters from "./DrugTestFilters";
import DataTable from "../../../components/DataTable";
import { DRUG_TEST_COLUMNS } from "./columns";
import PageHeader from "../../../components/DrugTests/PageHeader";
import {
  AddDrugTestForm,
  AddDrugTestBatchForm
} from "../../../components/DrugTests";
import { ModalContext } from "../../../components/ModalProvider";
import {
  getFilterState,
  saveFilterState,
  ourToast as toast
} from "../../../utils";
import { Confirmation } from "../../../components/modals";
import Loading from "../../../components/Loading";

class CustomDrugTestError extends Error {}

const DrugTestsPage = () => {
  const INITIAL_FILTER_STATE = getFilterState("DRUG_TEST_FILTERS", {
    Status: true
  });
  const client = useApolloClient();
  const history = useHistory();
  const { id } = useParams();

  const [closeDrugTestBatchNo, { loading }] = useMutation(
    CLOSE_DRUG_TEST_BATCH_NO_MUTATION
  );

  const [modalOpenned, setModalOpenned] = useState(false);
  const { setModalOpen, isModalOpen } = useContext(ModalContext);
  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);

  useEffect(() => {
    if (id && !modalOpenned) {
      setModalOpenned(true);
      const onComplete = (navigate = true) => {
        setModalOpenned(false);
        setModalOpen(false, "");
        if (navigate) {
          history.push("/hr/drug-tests");
        }
      };
      if (id === "add") {
        setModalOpen(true, <AddDrugTestForm onComplete={onComplete} />);
      } else {
        setModalOpen(
          true,
          <AddDrugTestForm RecId={id} onComplete={onComplete} />
        );
      }
    }
  }, [history, id, isModalOpen, modalOpenned, setModalOpen]);

  const handleSetFilters = inputs => {
    Object.keys(inputs).forEach(
      key =>
        typeof inputs[key] !== "boolean" &&
        (!inputs[key] ||
          inputs[key] === 0 ||
          inputs[key] === "" ||
          inputs[key].length === 0) &&
        delete inputs[key]
    );
    // Seting up the Filters values
    const Filters = {};
    Object.keys(inputs).forEach(
      key =>
        (Filters[key] =
          inputs[key] && inputs[key].value ? inputs[key].value : inputs[key])
    );
    setFilters({
      ...Filters,
      Status: inputs.Status
    });
    saveFilterState("DRUG_TEST_FILTERS", Filters);
  };
  const resetFilters = () => handleSetFilters({ Status: true });

  const onCloseBatchClick = () => {
    const performClose = async () => {
      try {
        setModalOpen(false, "");
        const { data: BatchInfoData } = await client.query({
          query: ALL_DRUG_TESTS_VIEW_QUERY,
          variables: {
            where: {
              BatchNo: filters.BatchNo
            }
          }
        });

        if (
          BatchInfoData.VW_DrugTests.some(
            drugTest => drugTest.Disposition === "Selected"
          )
        ) {
          throw new CustomDrugTestError(
            "Please ensure all dispositions have been updated from Selected."
          );
        }
        await closeDrugTestBatchNo({
          variables: {
            BatchNo: parseInt(filters.BatchNo)
          }
        });
        toast.success("Batch closed successfully.");
        resetFilters();
      } catch (err) {
        if (err instanceof CustomDrugTestError) {
          toast.error(err.message);
        } else {
          toast.error(`Error closing batch.`);
        }
      }
    };
    setModalOpen(
      true,
      <Confirmation
        message="Are you sure you would like to close this batch?"
        onConfirm={performClose}
      />
    );
  };

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={DrugTestFilters}
        columns={DRUG_TEST_COLUMNS}
        filters={filters}
        name="VW_DrugTests"
        query={ALL_DRUG_TESTS_VIEW_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Drug Test"
        onAddBatchClick={() =>
          setModalOpen(
            true,
            <AddDrugTestBatchForm
              onComplete={BatchNo => {
                setModalOpen(false, "");
                setFilters({
                  ...filters,
                  BatchNo
                });
              }}
            />
          )
        }
        onAddClick={() => {
          history.push("/hr/drug-tests/add");
          setModalOpenned(false);
        }}
        onCloseBatchClick={onCloseBatchClick}
      />
      {loading ? (
        <Loading />
      ) : (
        <DataTable
          columns={DRUG_TEST_COLUMNS}
          dataQuery={ALL_DRUG_TESTS_VIEW_QUERY}
          initialSortBy={[
            { id: "BatchNo", desc: false },
            { id: "EmployeeName", desc: false }
          ]}
          name="VW_DrugTest"
          paginationQuery={DRUG_TEST_PAGINATION_QUERY}
          where={filters}
          onRowClick={data => {
            history.push(`/hr/drug-tests/${data.RecId}`);
            setModalOpenned(false);
          }}
        />
      )}
    </React.Fragment>
  );
};
DrugTestsPage.propTypes = {};
export default DrugTestsPage;
